import { EventEmitter, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { IPageScrollConfig } from '@bca-core/modules/page-scroll/models/page-scroll-config';
import { ScrollPositionId } from '@bca-shared/models/_enums';
import { ProductId } from '@bca-shared/models/_types';
import { PageScrollOptions, PageScrollService as ngxPageScrollService } from 'ngx-page-scroll-core';

@Injectable()
export class PageScrollService {
  constructor(
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _page: ngxPageScrollService
  ) {}

  /**
   * Scrolls to the given target.
   *
   * Example: if target is 'test', scrolls to element with id: 'test'
   * @param target The target element
   * @param config Additional configuration
   * @returns returns true when the scrolling is finnished and false if interrupted
   */
  public async scrollTo(
    target: ScrollPositionId | ProductId,
    config?: IPageScrollConfig
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      setTimeout(async () => {
        const scrollConfig: PageScrollOptions = {
          document: this._document,
          scrollTarget: `#${target}`,
          scrollFinishListener: new EventEmitter<boolean>(),
          ...config
        };

        const { scrollFinishListener } = scrollConfig;
        this._page.scroll({ ...scrollConfig });
        resolve(await scrollFinishListener.toPromise());
      }, (config && config.timeout) || 50);
    });
  }
}
